import { GetCustomizeCar_customizeCar_prices } from '../../graphql/queries/__generated__/GetCustomizeCar';
import usePrice from '../../../gqlCommon/hooks/prices/usePrice';
import useMoney from '../../../gqlCommon/hooks/prices/useMoney';
import useTaxes from '../../../gqlCommon/hooks/useTaxes';

const useCarPrices = (prices: GetCustomizeCar_customizeCar_prices) => {
  const { primaryPrice: primaryOriginalPrice, secondaryPrice: secondaryOriginalPrice } = usePrice(
    prices.carPrice.originalPrice,
  );
  const { primaryPrice: primaryTotalDiscount, secondaryPrice: secondaryTotalDiscount } = useMoney(
    prices.carPrice.totalDiscount,
  );
  const { primaryPrice: primaryFinalPrice, secondaryPrice: secondaryFinalPrice } = usePrice(prices.carPrice.finalPrice);
  const taxes = useTaxes(prices.carPrice.finalPrice);
  const { discounts } = prices.carPrice.offers;

  const originalPrice = [primaryOriginalPrice, secondaryOriginalPrice];
  const totalDiscount = [primaryTotalDiscount, secondaryTotalDiscount];
  const finalPrice = [primaryFinalPrice, secondaryFinalPrice];

  return { originalPrice, totalDiscount, finalPrice, discounts, taxes };
};

export default useCarPrices;
